import React, { useState } from 'react';
import UserManagement from './UserManagement';
import RoleManagement from './RoleManagement';

/**
 * Container component with tabs for User Management and Role Management
 */
const UserAndRoleManagement = () => {
  const [activeTab, setActiveTab] = useState('users'); // 'users' or 'roles'

  return (
    <div className="h-full flex flex-col">
      {/* Tab Headers */}
      <div className="bg-white border-b border-gray-200">
        <div className="px-6">
          <nav className="flex space-x-8" aria-label="Tabs">
            <button
              onClick={() => setActiveTab('users')}
              className={`
                py-4 px-1 border-b-2 font-medium text-sm transition-colors
                ${activeTab === 'users'
                  ? 'border-[#C7AE6E] text-[#C7AE6E]'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                }
              `}
            >
              👥 Users
            </button>
            <button
              onClick={() => setActiveTab('roles')}
              className={`
                py-4 px-1 border-b-2 font-medium text-sm transition-colors
                ${activeTab === 'roles'
                  ? 'border-[#C7AE6E] text-[#C7AE6E]'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                }
              `}
            >
              🔑 Roles & Permissions
            </button>
          </nav>
        </div>
      </div>

      {/* Tab Content */}
      <div className="flex-1 overflow-auto">
        {activeTab === 'users' ? <UserManagement /> : <RoleManagement />}
      </div>
    </div>
  );
};

export default UserAndRoleManagement;

